module.exports = __webpack_public_path__ + "static/media/er.692c2f36.svg";